import Grid from "@mui/material/Unstable_Grid2/Grid2";
import {  Typography } from '@mui/material';
import { UBItem } from './UBItem';
import { shortenNumber, shortenFloat } from "../../utils/number";

export const UBMetric = ({ id, title, events, titleStatus, eventsStatus, compact = false, sectioned = false }) => {
    return (
        <UBItem id={id} title={title} titleStatus={titleStatus} childrenStatus={eventsStatus} styles={{}}>
            <Grid container spacing={2} py={2} px={1} justifyContent="center" alignItems="center">
                {events?.map(event => {
                    return (
                        <>
                            {!event?.metrics ?
                                <Grid sm={12} md={12}>
                                    <Typography align="left">{event?.event_label}</Typography>
                                </Grid>
                                :
                                <>
                                    {event?.event_label &&
                                        <Grid sm={12} md={12}>
                                            <Typography align="left">{event?.event_label}</Typography>
                                        </Grid>
                                    }

                                    {event?.response_time !== undefined &&
                                        <Grid sm={12} md={12} pl={sectioned ? 3 : 1}>
                                            <Typography align="left">{`Avg Resp Time (P0): ${shortenFloat(event?.response_time)}s`}</Typography>
                                        </Grid>
                                    }

                                    {event?.metrics?.map((metric, index) => {
                                        return (
                                            <>
                                                <Grid md={1} pl={sectioned ? 3 : 1}>
                                                    <Typography align="right">{metric?.channel}: </Typography>
                                                </Grid>
                                                <Grid md={compact ? 4 : 3}>
                                                    <Typography align="right">{shortenNumber(metric?.value)}</Typography>
                                                </Grid>
                                            </>
                                        )
                                    })}
                                </>
                            }
                        </>
                    );
                })}
            </Grid>
        </UBItem>
    );
}